import { DateTime } from "luxon"

const today = DateTime.now()
const oneMonthAgo = DateTime.now().minus({ months: 1 })

export const completedTransferParams = { "filter[start_date]": oneMonthAgo.toISODate(), "filter[end_date]": today.toISODate() }